<template>
    <v-row class="wrapper">
        <v-col
            v-show="form.ID_RCA"
            sm="12"
            md="8"
            offset-md="2"
        >
            <v-card>
                <v-card-title class="primary--text">
                    RCA
                </v-card-title>
                <v-card-text>
                    <v-form
                        ref="form"
                        @submit.prevent="enviarSolicitacao"
                    >
                        <v-row>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.ID_RCA"
                                    filled
                                    readonly
                                    label="ID"
                                />
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.CREATED_AT ? new Date(form.CREATED_AT).toLocaleString() : ''"
                                    filled
                                    readonly
                                    label="CRIADO EM"
                                />
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.UPDATED_AT ? new Date(form.UPDATED_AT).toLocaleString(): ''"
                                    filled
                                    readonly
                                    label="ATUALIZADO EM"
                                />
                            </v-col>
                        </v-row>

                        <v-text-field
                            :value="form.EMPRESA"
                            filled
                            readonly
                            label="EMPRESA"
                        />

                        <v-text-field
                            :value="form.ENDERECO"
                            filled
                            readonly
                            label="ENDEREÇO"
                        />

                        <v-row>
                            <v-col
                                cols="10"
                                class="py-0"
                            >
                                <v-text-field
                                    :value="form.CIDADE"
                                    filled
                                    readonly
                                    label="CIDADE"
                                />
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.ESTADO"
                                    filled
                                    readonly
                                    label="ESTADO"
                                />
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.TELEFONE_CELULAR"
                                    filled
                                    readonly
                                    label="TELEFONE CELULAR"
                                />
                            </v-col>
                            <v-col class="py-0">
                                <v-text-field
                                    :value="form.TELEFONE_FIXO"
                                    filled
                                    readonly
                                    label="TELEFONE FIXO"
                                />
                            </v-col>
                        </v-row>

                        <v-text-field
                            :value="form.RESPONSAVEL_COMERCIAL"
                            filled
                            readonly
                            label="RESPONSÁVEL COMERCIAL"
                        />

                        <v-select
                            v-model="listMarcasRepresentadas"
                            :items="listMarcasRepresentadas"
                            filled
                            small-chips
                            multiple
                            readonly
                            label="MARCAS REPRESENTADAS"
                            class="select-marcas-representadas"
                        />

                        <v-text-field
                            :value="form.REGIAO_ATUACAO"
                            filled
                            readonly
                            label="REGIÃO DE ATUAÇÃO"
                        />

                        <v-select
                            v-model="form.ID_STATUS_RCA"
                            :items="statusList"
                            item-value="ID_STATUS_RCA"
                            item-text="NOME"
                            outlined
                            label="STATUS"
                        />

                        <v-textarea
                            v-model="form.OBSERVACAO"
                            outlined
                            label="OBSERVAÇÃO"
                            placeholder="digite uma observação"
                            rows="3"
                            maxlength="500"
                            counter
                        />

                        <v-layout justify-space-between>
                            <div>
                                <v-btn
                                    large
                                    text
                                    color="primary"
                                    @click="() => printDocument()"
                                >
                                    <v-icon left>
                                        mdi-printer
                                    </v-icon>
                                    Imprimir
                                </v-btn>

                                <v-btn
                                    large
                                    text
                                    color="primary"
                                    :href="fileDownloadLink"
                                >
                                    <v-icon left>
                                        mdi-file-download-outline
                                    </v-icon>
                                    Baixar anexo
                                </v-btn>
                            </div>

                            <v-btn
                                large
                                color="primary"
                                @click="atualizarRCA"
                            >
                                <v-icon left>
                                    mdi-check
                                </v-icon>
                                Atualizar Dados
                            </v-btn>
                        </v-layout>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import api from '../../../services/api';

    export default {
        data() {
            return {
                form: {
                    ID_RCA: null,
                    CREATED_AT: null,
                    EMPRESA: null,
                    ENDERECO: null,
                    CIDADE: null,
                    ESTADO: null,
                    TELEFONE_CELULAR: null,
                    TELEFONE_FIXO: null,
                    RESPONSAVEL_COMERCIAL: null,
                    MARCAS_REPRESENTADAS: null,
                    REGIAO_ATUACAO: null,
                    FILE_CURRICULUM_APRESENTACAO: null,
                    ID_STATUS_RCA: null,
                    OBSERVACAO: null
                },

                statusList: []
            };
        },

        computed: {
            listMarcasRepresentadas() {
                if (this.form.MARCAS_REPRESENTADAS) {
                    const list = this.form.MARCAS_REPRESENTADAS.split(',');

                    list.forEach(item => item = item.toString().trim());

                    return list;
                }

                return [];
            },

            fileDownloadLink() {
                const folder = this.$root.config.CURRICULUM_APRESENTACAO_UPLOAD_FOLDER;
                const filename = this.form.FILE_CURRICULUM_APRESENTACAO;
                const userData = localStorage.getItem('USER') && JSON.parse(localStorage.getItem('USER'));

                if (folder && filename && userData) {
                    return `${this.$root.config.API_URL}/admin/files?folder=${folder}&filename=${filename}&token=${userData.TOKEN}`;
                }

                return null;
            }
        },

        created() {
            this.fetchSolicitacao();
            this.fetchStatusList();
        },

        methods: {
            async fetchSolicitacao() {
                try {
                    const response = await api.getRCAByID(this.$route.params.id);

                    this.form = response.data;
                } catch (error) {
                    if (error.response && error.response.status === 404) {
                        this.$router.push('/painel-rca');
                    }
                }
            },

            async fetchStatusList() {
                try {
                    const response = await api.getStatusRCA();

                    this.statusList = response.data;
                } catch (error) {}
            },

            async atualizarRCA() {
                try {
                    await api.updateRCA(this.form.ID_RCA, this.form);

                    await this.fetchSolicitacao();

                    this.$root.$emit('message', { text: 'Dados atualizados com sucesso!', color: 'success' });
                } catch (error) {
                    this.$root.$emit('message', { text: 'Erro ao atualizar os dados.', color: 'error' });
                }
            },

            printDocument() {
                window.print();
            }
        }
    };
</script>

<style scoped>
    .select-marcas-representadas >>> .v-chip--select.v-chip.v-chip--disabled.v-chip--no-color.theme--light.v-size--small {
        border: 1px solid #388e3c !important;
        color: #388e3c !important;
        background: transparent !important;
        opacity: 1 !important;
        margin: 0 5px 0 0 !important;
    }

    .select-marcas-representadas >>> .v-input__append-inner {
        display: none !important;
    }
</style>